<template>
  <div v-loading="isLoading1 || isLoading2" element-loading-text="拼命加载中">
    <div class="warpper">
      <div class="banner_wrapper">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item>好近小店二维码</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="panel">
        <div class="panel-header">
          <div class="panel-select-group">
            <span class="panel-header__desc">输入桌牌信息</span>
          </div>
        </div>
        <div class="panel-body" style="padding:30px 0">
          <el-row>
            <el-col :span="10" style="padding:180px 12% 0 8%;">
              <el-form label-position="top" label-width="80px" :model="tabelForm" ref="tabelForm" :rules="rules">
                <el-form-item label="桌牌数量">
                  <el-form-item prop="endNum">
                    <el-input v-model.number="tabelForm.endNum" placeholder="请输入生成桌牌的数量"></el-input>
                  </el-form-item>
                  <div class="explain">请填写纯数字</div>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" :disabled="createBtnDisabled" @click="submitForm('tabelForm')">生成二维码</el-button>
                  <el-button :disabled="resetDisabled" @click="reset()">重置</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="14" style="text-align:center;border-left:1px solid #e7eaec;padding:0 60px;">
              <figure v-show="isPreview">
                <img src="./img/qrcode-demo.png" alt="二维码预览" class="pic-preview">
                <p style="padding-top:15px;">二维码预览</p>
              </figure>
              <div v-show="!isPreview" class="realQrcode">
                <figure id="tablePreview">
                  <canvas width="350" height="455"></canvas>
                  <p>已生成<em>{{tabelForm.endNum}}</em>个桌贴</p>
                  <el-button type="primary" :disabled="downloadTabelBtnDisabled" @click="downloadTabel()">下载桌贴</el-button>
                </figure>
                <figure id="qrcodePreview">
                  <canvas width="350" height="455"></canvas>
                  <p>已生成<em>{{tabelForm.endNum}}</em>个二维码</p>
                  <el-button type="primary" :disabled="downloadQrcodeBtnDisabled" @click="downloadQrcode()">下载二维码</el-button>
                </figure>
              </div>
            </el-col>
          </el-row>
          <img id="bg" src="./img/bg.jpg" alt="点餐桌贴" style="display:none">
          <div id="tableQrcodeContainer" style="display:none"></div>
          <div id="qrcodeContainer" style="display:none"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from 'config'
  import QRCode from 'qrcode'
  import Store from '../../common/js/store'

  export default {
    data () {
      return {
        isLoading1: false,
        isLoading2: false,
        hasPublic: false,
        tabelForm: {
          areaName: '',
          endNum: ''
        },
        tab: '',
        isPreview: true,
        createBtnDisabled: false,
        resetDisabled: false,
        downloadTabelBtnDisabled: false,
        downloadQrcodeBtnDisabled: false,
        uid: Store.get('uid'),
        rules: {
          'endNum': [
            {pattern: /^(0|[1-9][0-9]*)$/, message: '桌号必须为数字'}
          ]
        }
      }
    },
    created () {
    },
    methods: {
      reset() {
        this.$refs['tabelForm'].resetFields()
        this.isPreview = true
        this.createBtnDisabled = false
        this.downloadTabelBtnDisabled = false
        this.downloadQrcodeBtnDisabled = false
        let tableNode = document.getElementById('tableQrcodeContainer')
        while (tableNode.firstChild) {
          tableNode.removeChild(tableNode.firstChild)
        }
        let qrcodeNode = document.getElementById('qrcodeContainer')
        while (qrcodeNode.firstChild) {
          qrcodeNode.removeChild(qrcodeNode.firstChild)
        }
      },
      
      submitForm (formName) {
        this.createBtnDisabled = true
        let endNum = this.tabelForm.endNum
        if (!endNum) {
          this.$message('桌牌数量不能都为空')
          this.createBtnDisabled = false
          return false
        } else if (endNum > 10) {
          this.$message('单次最多生成10个二维码')
          this.createBtnDisabled = false
          return false
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
          this.resetDisabled = true;
          axios.get(`${config.host}/merchant/third/qimai/qrcode/get?num=${endNum}`)
          .then((res) => {
            let data = res.data
            if (data.respcd === '0000') {
              let qrcodeUrlList = data.data.qrcode_urls
              for (let i = 0; i < qrcodeUrlList.length; i++) {
                this.urlToQrcode((i + 1), qrcodeUrlList[i])
              }
              this.isPreview = false
            } else {
              this.$message.error(data.respmsg)
            }
            this.resetDisabled = false;
          })
          .catch(() => {
            this.$message.error('获取二维码链接失败');
            this.resetDisabled = false;
          })
          } else {
            this.createBtnDisabled = false
            return false
          }
        })
      },
      
      drawPreviewCanvas (qrcode, hasFrame, tableNumber) {
        let domName = hasFrame ? 'tablePreview' : 'qrcodePreview'
        let canvas = document.getElementById(domName).firstElementChild
        let ctx = canvas.getContext('2d')
        canvas.width = qrcode.width
        canvas.height = qrcode.height + 50
        ctx.rect(0, 0, qrcode.width, qrcode.height + 50)
        ctx.fillStyle = '#ffffff'
        ctx.fill()

        ctx.fillStyle = '#fe9b20'
        ctx.font = 'bold 22px 黑体'
        ctx.textAlign = 'center'

        let qrcodeCtx = qrcode.getContext("2d")
        let imgData = qrcodeCtx.getImageData(0, 0, qrcode.width, qrcode.height)
        ctx.putImageData(imgData, 0, 0)
      },
      urlToQrcode (tableNumber, qrcodeUrl) {
        let qrcode = document.createElement('canvas')
        QRCode.toCanvas(qrcode, qrcodeUrl, {scale: 8, margin: 0}, function (err) {
          if (err) throw err
        })
        this.drawTableCanvas(qrcode, tableNumber)
        this.drawQrcodeCanvas(qrcode, tableNumber)
        if (tableNumber === 1) {
          this.drawPreviewCanvas(qrcode, true, tableNumber)
          this.drawPreviewCanvas(qrcode, false, tableNumber)
        }
      },
      // 绘制第一张真实桌牌
      drawTableCanvas (qrcode, tableNumber) {
        let canvas = document.createElement('canvas')
        canvas.setAttribute('name', tableNumber)
        let ctx = canvas.getContext('2d')
        canvas.width = 430
        canvas.height = 600
        ctx.rect(0, 0, canvas.width, canvas.height)
        ctx.fill()

        let bg = document.getElementById('bg')
        ctx.drawImage(bg, 0, 0, canvas.width, canvas.height)

        ctx.fillStyle = '#fe9b20'
        ctx.font = 'bold 22px 黑体'
        ctx.textAlign = 'center'

        let qrcodeCtx = qrcode.getContext('2d')
        let imgData = qrcodeCtx.getImageData(0, 0, qrcode.width, qrcode.height)
        ctx.putImageData(imgData, 97, 162)

        document.getElementById('tableQrcodeContainer').append(canvas)
      },
      drawQrcodeCanvas (qrcode, tableNumber) {
        let canvas = document.createElement('canvas')
        canvas.setAttribute('name', tableNumber)
        let ctx = canvas.getContext('2d')
        canvas.width = qrcode.width
        canvas.height = qrcode.height + 50
        ctx.rect(0, 0, qrcode.width, qrcode.height + 50)
        ctx.fillStyle = '#ffffff'
        ctx.fill()

        ctx.fillStyle = '#fe9b20'
        ctx.font = 'bold 22px 黑体'
        ctx.textAlign = 'center'

        let qrcodeCtx = qrcode.getContext('2d')
        let imgData = qrcodeCtx.getImageData(0, 0, qrcode.width, qrcode.height)
        ctx.putImageData(imgData, 0, 0)

        document.getElementById('qrcodeContainer').append(canvas)
      },
      downloadFile(fileName, canvas) {
        let a = document.createElement('a')
        a.setAttribute('download', fileName)
        a.setAttribute('href', canvas.toDataURL())
        a.click()
      },
      downloadTabel () {
        this.downloadTabelBtnDisabled = true
        let tables = document.getElementById('tableQrcodeContainer').childNodes
        for (let i = 0; i < tables.length; i++) {
          this.downloadFile(tables[i].getAttribute('name'), tables[i])
        }
      },
      downloadQrcode (e) {
        this.downloadQrcodeBtnDisabled = true
        let qrcodes = document.getElementById('qrcodeContainer').childNodes
        for (let i = 0; i < qrcodes.length; i++) {
          this.downloadFile(qrcodes[i].getAttribute('name'), qrcodes[i])
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .pic-preview {
    width: 330px;
    border-radius:8px;
    border:1px solid rgba(229,229,229,1);
  }
  .el-form-item {
    margin-bottom: 22px;
  }

  .el-form-item__label {
    font-size: 20px;
    color: #262424;
  }

  .explain {
    color: #98989e;
    line-height: 20px;
    font-size: 15px;
  }

  .realQrcode {
    figure {
      width: 45%;
      display: inline-block;
    }
    canvas {
      width: 52%;
      margin-top: 28%;
      border: 3px solid #f2932f;
      border-radius: 6px;
      padding: 10px 10px 0;
    }
    p {
      margin: 32% 0 20px;;
    }
    em {
      color: #fe9b20;
      margin: 0 8px;
    }
  }
  #tablePreview {
    background: url('./img/qr-1.jpg') no-repeat;
    background-size: 100% auto;
  }
  #qrcodePreview {
    background: url('./img/qr-2.jpg') no-repeat;
    background-size: 100% auto;
  }
</style>



// WEBPACK FOOTER //
// qrcode.vue?2b6a4850